<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre7 sgc-15 sgc-49 sigilNotInTOC" id="heading_id_2">Contents</h1>
<p class="calibre9"><a href="#/Text/Chapter01">Curtain Raiser</a></p>
<p class="calibre5"><a href="#/Text/Chapter02">Dramatis Personae</a></p>
<p class="calibre5"><span href="#/Text/Chapter03" title="Link target outside of Sample">Rehearsals</span></p>
<p class="calibre5"><span href="#/Text/Chapter04" title="Link target outside of Sample">Entr’acte (Saturday Morning, Causton High Street)</span></p>
<p class="calibre5"><span href="#/Text/Chapter05" title="Link target outside of Sample">First Night</span></p>
<p class="calibre5"><span href="#/Text/Chapter06" title="Link target outside of Sample">Enter the Broker’s Men</span></p>
<p class="calibre5"><span href="#/Text/Chapter07" title="Link target outside of Sample">Exit, Pursued by a Bear</span></p>
<p class="calibre5"><span href="#/Text/Chapter08" title="Link target outside of Sample">Another Opening, Another Show</span></p>
<p class="calibre5"><span href="#/Text/Chapter09" title="Link target outside of Sample">Read the Prologue and first chapter of <span class="calibre3">Death in Disguise</span>, the next title in the “Inspector Barnaby” series!</span></p>
<p class="calibre5"><span href="#/Text/Part01" title="Link target outside of Sample">Two Deaths</span></p>
<p class="calibre5"><span href="#/Text/Chapter10" title="Link target outside of Sample">Chapter One</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?9a54d13e